/* eslint-disable react/require-default-props */
import {
  AvmFactorsData,
  AvmInferenceData,
  WorkOrderData,
} from '../../../api/workOrders/types';
import { factorTypes } from '../../../constants/evaluationTypes';
import { privateUnitsGroup } from '../../../constants/selectOptions';
import { FactorsReport } from './FactorsReport';
import { InferenceReport } from './InferenceReport';

interface ReportInfoProps {
  propertyData: WorkOrderData;
  getCharts?: (img: HTMLCanvasElement, title: string) => Promise<void>;
  forceFactors?: string[];
  forceTransformations?: string[];
}
export function ReportInfo({
  propertyData,
  getCharts,
  forceFactors,
  forceTransformations,
}: ReportInfoProps): JSX.Element {
  return factorTypes.includes(propertyData?.evaluation_type) ? (
    <FactorsReport
      tableData={propertyData?.avm_report as AvmFactorsData}
      chartCallback={getCharts}
      forceFactors={forceFactors}
      isPrivateUnit={privateUnitsGroup.has(propertyData.real_estate_kind)}
      highPrice={propertyData.sample_sell_price_above_400k || false}
    />
  ) : (
    <InferenceReport
      tableData={propertyData?.avm_report as AvmInferenceData}
      chartCallback={getCharts}
      refNumber={propertyData?.reference_number}
      transformations={forceTransformations}
    />
  );
}
